/* eslint-disable no-unused-vars */
import { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import "./ChartNode.css";
import { useSelector } from "react-redux";

const propTypes = {
  datasource: PropTypes.object,
  NodeTemplate: PropTypes.elementType,
  collapsible: PropTypes.bool,
};

const defaultProps = {
  collapsible: true,
};

const ChartNode = ({ datasource, NodeTemplate, collapsible, meterData }) => {
  const node = useRef();

  const [isChildrenCollapsed, setIsChildrenCollapsed] = useState(true);
  const [topEdgeExpanded, setTopEdgeExpanded] = useState(true);
  const [rightEdgeExpanded, setRightEdgeExpanded] = useState(true);
  const [leftEdgeExpanded, setLeftEdgeExpanded] = useState(true);
  const [bottomEdgeExpanded, setBottomEdgeExpanded] = useState(true);

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  const isChild = datasource?.IsMeterNode;

  const nodeClass = [
    "oc-node",
    isChild ? "isChild" : "isParent",
    isChildrenCollapsed ? "isChildrenCollapsed" : "",
  ]
    .filter((item) => item)
    .join(" ");

  // const addArrows = (e) => {
  //   const node = e.target.closest("li"); // get the target hover node
  //   const parent = node.parentNode.closest("li"); // get the parent ele of that node
   

  //   console.log(parent)
  //   // collapse => shrink
  //   const isAncestorsCollapsed =
  //     node && parent
  //       ? parent.firstChild.classList.contains("hidden") // set true if granparent className is hidden if node & parent is true
  //       : undefined;
  //   const isSiblingsCollapsed = Array.from(node.parentNode.children).some(
  //     (item) => item.classList.contains("hidden")
  //   ); // set true if Sibling is shrinked else false.

  //   setTopEdgeExpanded(!isAncestorsCollapsed);
  //   setRightEdgeExpanded(!isSiblingsCollapsed);
  //   setLeftEdgeExpanded(!isSiblingsCollapsed);
  //   setBottomEdgeExpanded(!isChildrenCollapsed);
  // };


  const addArrows = (e) => {
    const node = e.target.closest("li"); // get the target hover node
    if (!node) return; // If node is null, exit the function
  
    const parent = node.parentNode.closest("li"); // get the parent ele of that node
    if (!parent) return; // If parent is null, exit the function
  
    // collapse => shrink
    const isAncestorsCollapsed = parent.firstChild.classList.contains("hidden"); // set true if granparent className is hidden if node & parent is true
    const isSiblingsCollapsed = Array.from(node.parentNode.children).some(
      (item) => item.classList.contains("hidden")
    ); // set true if Sibling is shrinked else false.
  
    setTopEdgeExpanded(!isAncestorsCollapsed);
    setRightEdgeExpanded(!isSiblingsCollapsed);
    setLeftEdgeExpanded(!isSiblingsCollapsed);
    setBottomEdgeExpanded(!isChildrenCollapsed);
  };
  
  


  const removeArrows = () => {
    // setTopEdgeExpanded(undefined);
    setRightEdgeExpanded(undefined);
    setLeftEdgeExpanded(undefined);
  };



  

  // const toggleAncestors = (actionNode) => {
  //   let node = actionNode.parentNode.closest("li");
  //   if (!node) return;
  //   const isAncestorsCollapsed = node.firstChild.classList.contains("hidden");
  //   if (isAncestorsCollapsed) {
  //     actionNode.classList.remove("isAncestorsCollapsed");
  //     node.firstChild.classList.remove("hidden");
  //   } else {
  //     const isSiblingsCollapsed = Array.from(
  //       actionNode.parentNode.children
  //     ).some((item) => item.classList.contains("hidden"));
  //     if (!isSiblingsCollapsed) {
  //       toggleSiblings(actionNode);
  //     }
  //     actionNode.classList.add(
  //       ...(
  //         "isAncestorsCollapsed" +
  //         (isSiblingsCollapsed ? "" : " isSiblingsCollapsed")
  //       ).split(" ")
  //     );
  //     node.firstChild.classList.add("hidden");
  //     if (
  //       node.parentNode.closest("li") &&
  //       !node.parentNode.closest("li").firstChild.classList.contains("hidden")
  //     ) {
  //       toggleAncestors(node);
  //     }
  //   }
  // };

  // expand / close
  
  const toggleAncestors = (actionNode) => {
    let node = actionNode.parentNode.closest("li");
    if (!node) return;
    const isAncestorsCollapsed = node.firstChild.classList.contains("hidden");
    if (isAncestorsCollapsed) {
      actionNode.classList.remove("isAncestorsCollapsed");
      node.firstChild.classList.remove("hidden");
    } else {
      const isSiblingsCollapsed = Array.from(
        actionNode.parentNode.children
      ).some((item) => item.classList.contains("hidden"));
      if (!isSiblingsCollapsed) {
        toggleSiblings(actionNode);
      }
      actionNode.classList.add(
        ...(
          "isAncestorsCollapsed" +
          (isSiblingsCollapsed ? "" : " isSiblingsCollapsed")
        ).split(" ")
      );
      node.firstChild.classList.add("hidden");
      if (
        node.parentNode.closest("li") &&
        !node.parentNode.closest("li").firstChild.classList.contains("hidden")
      ) {
        toggleAncestors(node);
      }
    }
  };
  
  
  const toggleSiblings = (actionNode) => {
    let node = actionNode.previousSibling;
    const isSiblingsCollapsed = Array.from(actionNode.parentNode.children).some(
      (item) => item.classList.contains("hidden")
    );
    actionNode.classList.toggle("isSiblingsCollapsed", !isSiblingsCollapsed);
    while (node) {
      if (isSiblingsCollapsed) {
        node.classList.remove("hidden");
      } else {
        node.classList.add("hidden");
      }
      node = node.previousSibling;
    }
    node = actionNode.nextSibling;
    while (node) {
      if (isSiblingsCollapsed) {
        node.classList.remove("hidden");
      } else {
        node.classList.add("hidden");
      }
      node = node.nextSibling;
    }
    const isAncestorsCollapsed = actionNode.parentNode
      .closest("li")
      .firstChild.classList.contains("hidden");
    if (isAncestorsCollapsed) {
      toggleAncestors(actionNode);
    }
  };
  const topEdgeClickHandler = (e) => {
    e.stopPropagation();
    setTopEdgeExpanded(!topEdgeExpanded);
    toggleAncestors(e.target.closest("li"));
  };

  const hEdgeClickHandler = (e) => {
    e.stopPropagation();
    setLeftEdgeExpanded(!leftEdgeExpanded);
    setRightEdgeExpanded(!rightEdgeExpanded);
    toggleSiblings(e.target.closest("li"));
  };

  const bottomEdgeClickHandler = (e) => {
    e.stopPropagation();
    setIsChildrenCollapsed(!isChildrenCollapsed);
    setBottomEdgeExpanded(!bottomEdgeExpanded);
  };


  return (
    <>
      <li className={`oc-hierarchy`}>
        <div
          ref={node}
          id={datasource?.id}
          className={nodeClass}
          onMouseEnter={addArrows}
          onMouseLeave={removeArrows}
        >
          {NodeTemplate ? (
            <>
              <NodeTemplate nodeData={datasource} meterData={meterData} />
            </>
          ) : (
            <>
              <div className="oc-heading">
                {datasource?.relationship &&
                  datasource?.relationship.charAt(2) === "1" && (
                    <i className="oci oci-leader oc-symbol" />
                  )}
                {datasource?.EntityName}
              </div>
              <div className="oc-content">SPC{datasource?.SPC}</div>
              <div className="oc-content">Kwh{datasource?.Kwh}</div>
            </>
          )}

          {collapsible &&
            datasource?.relationship &&
            datasource?.relationship.charAt(2) === "1" && (
              <i
                className={`oc-edge verticalEdge bottomEdge oci ${
                  bottomEdgeExpanded === undefined
                    ? ""
                    : bottomEdgeExpanded
                    ? "oci-chevron-down"
                    : "oci-chevron-down"
                }`}
                onClick={bottomEdgeClickHandler}
              />
            )}
          {collapsible &&
            datasource?.relationship &&
            datasource?.relationship.charAt(0) === "1" && (
              <i
                className={`oc-edge verticalEdge topEdge oci ${
                  topEdgeExpanded === undefined
                    ? ""
                    : topEdgeExpanded
                    ? "oci-chevron-up"
                    : "oci-chevron-down"
                }`}
                onClick={topEdgeClickHandler}
              />
            )}
          {collapsible &&
            datasource?.relationship &&
            datasource?.relationship.charAt(1) === "1" && (
              <>
                <i
                  className={`oc-edge horizontalEdge rightEdge oci ${
                    rightEdgeExpanded === undefined
                      ? ""
                      : rightEdgeExpanded
                      ? "oci-chevron-left"
                      : "oci-chevron-right"
                  }`}
                  onClick={hEdgeClickHandler}
                />
                <i
                  className={`oc-edge horizontalEdge leftEdge oci ${
                    leftEdgeExpanded === undefined
                      ? ""
                      : leftEdgeExpanded
                      ? "oci-chevron-right"
                      : "oci-chevron-left"
                  }`}
                  onClick={hEdgeClickHandler}
                />
              </>
            )}
        </div>

        {datasource?.children && datasource?.children?.length > 0 && (
          <ul className={isChildrenCollapsed ? "hidden" : ""}>
            {datasource?.children?.map((node, index) => (
              <ChartNode
                datasource={node}
                NodeTemplate={NodeTemplate}
                id={node?.id}
                key={index}
                collapsible={collapsible}
                meterData={meterData}
              />
            ))}
          </ul>
        )}
      </li>
    </>
  );
};

ChartNode.propTypes = propTypes;
ChartNode.defaultProps = defaultProps;

export default ChartNode;
